import { VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { useAutoScrollOnDrag } from 'shared/components/DragNDrop/hooks/useAutoScrollOnDrag';

type TBoardColumn = {
  children: ReactNode;
  spacing?: number | string;
};

export const BoardColumn = ({ children, spacing = 0 }: TBoardColumn) => {
  const scrollRef = useAutoScrollOnDrag();

  return (
    <VStack
      ref={scrollRef}
      align="stretch"
      flex="1"
      gap={spacing}
      overflowY="auto"
      overflowX="hidden"
      p="8px"
      data-testid="board-column"
    >
      {children}
    </VStack>
  );
};
